<script>
import { h } from 'vue';
import { Form, FormItem, Button, Switch, Input, InputPassword, InputNumber, Textarea } from 'ant-design-vue';
import { DolIcon } from 'dolphin-framework-vue';
import DolSelect from '@/components/dolphin-ant-design/form/dol-select.vue';
import DolTreeSelect from '@/components/dolphin-ant-design/form/dol-tree-select.vue';
import DolIconSelect from '@/components/dolphin-ant-design/form/dol-icon-select.vue';
import DolDate from '@/components/dolphin-ant-design/form/dol-date.vue';
import DolCheckbox from '@/components/dolphin-ant-design/form/dol-checkbox.vue';
import DolRadio from '@/components/dolphin-ant-design/form/dol-radio.vue';
import DolUploadImg from '@/components/dolphin-ant-design/form/dol-upload-img.vue';
import DolUploadImgList from '@/components/dolphin-ant-design/form/dol-upload-img-list.vue';

const INPUT_TYPE = {
  select: DolSelect,
  dict: DolSelect,
  tagArray: DolSelect,
  ref: DolSelect,
  password: InputPassword,
  treeSelect: DolTreeSelect,
  number: InputNumber,
  boolean: Switch,
  switch: Switch,
  iconSelect: DolIconSelect,
  textarea: Textarea,
  date: DolDate,
  checkbox: DolCheckbox,
  radio: DolRadio,
  image: DolUploadImg,
  imageList: DolUploadImgList,
}

export default {
  name: 'dol-form-item',
  components: { DolSelect, DolTreeSelect },
  props: {
    field: { type: Object, default: () => [] },
    form: { type: Object, default: () => ({})},
    type: { type: String, default: 'editForm'},
  },
  data () {
    return {};
  },
  computed: {
    innerInputType(){
      return this.field ? (this.field.inputType || this.field.fieldType) : 'input';
    }
  },
  methods: {
    // 特殊查询条件的渲染
    renderSpecialCondition(formItemChildren){
      switch (this.innerInputType){
        case 'date': this.renderDateCondition(formItemChildren); break;
      }
    },
    renderDateCondition(formItemChildren){
      const activeKey = this.field.dataIndex + '_date_start';
      const expiredKey = this.field.dataIndex + '_date_end';
      formItemChildren.push(h(DolDate, {
        value: this.form[activeKey],
        'onUpdate:value': v => this.form[activeKey] = v,
      }));
      formItemChildren.push(h('span', '~'));
      formItemChildren.push(h(DolDate, {
        value: this.form[expiredKey],
        'onUpdate:value': v => this.form[expiredKey] = v,
      }));
    },

    // 统一渲染
    renderSingleComponent(){
      const inputComponent = INPUT_TYPE[this.field.inputType] || INPUT_TYPE[this.field.fieldType] || Input;

      const vModelParams = {};
      if(inputComponent === Switch){
        vModelParams.checked = this.form[this.field.dataIndex];
        vModelParams['onUpdate:checked'] = v => this.form[this.field.dataIndex] = v;
      }else{
        vModelParams.value = this.form[this.field.dataIndex];
        vModelParams['onUpdate:value'] = v => this.form[this.field.dataIndex] = v;
      }

      const inputParams = {
        ...vModelParams,
        ref: 'inputComponent',
      };
      if(this.field.editParams?.onChange) inputParams.onChange = this.field.editParams.onChange;
      if(this.field.dictCode) inputParams.dictCode = this.field.dictCode;
      switch (inputComponent){
        case Input:
          inputParams.autoComplete = 'off';
          inputParams.onPressEnter = () => this.$emit('pressEnter');
          // inputParams.allowClear = true;
          break;
        case Textarea:
          inputParams.autoSize = { minRows: 3};
          break;
      }
      Object.assign(inputParams, this.field.inputParams);
      if(this.type === 'editForm'){
        Object.assign(inputParams, this.field.editInputParams);
      }
      Object.assign(inputParams, this.field.innerParams);
      return h(inputComponent, inputParams, () => undefined);
    },
  },
  render(){
    const formItemParams = {
      label: this.field.title,
      name: this.field.dataIndex,
    };
    const formItemChildren = [];

    // 查询表单时，需要按范围查询
    if(this.type === 'queryForm' && /^(date)$/.test(this.innerInputType)){
      this.renderSpecialCondition(formItemChildren);
    }else{
      formItemChildren.push(this.renderSingleComponent())
    }

    return h(FormItem, formItemParams, () => formItemChildren);
  },
}
</script>

<style lang="scss">

</style>
